module.exports = __webpack_public_path__ + "b188c9bf5308d5e9c0a46863396e6645.svg";